import SubscriptionManagerDashboard from "./SubscriptionManagerDashboard"

export default  SubscriptionManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/index.js